import React from "react";

const Service = () => {
  return (
    <>
      <h1 className="text-center mt-5 co i">
        Types of Food and Beverage Service
      </h1>
      <p className="text-center">
        Understanding these 5 different types of food and beverage services and
        their benefits and challenges will help you decide which one to use for
        your restaurant.
      </p>
      <hr />
      <div className="container">
        <div className="row my-4">
          <div className="col-lg-4">
            <div className="card">
              <img
                src="assets/img/s2.jpg"
                className="img-thumbnail"
                alt="Crad Number Onr Image"
              />
              <h4 className="sh4 p-3">1. Waiter service</h4>
              <p className="px-2 text-center">
                More commonly known as sit-down service, this type of service
                requires a waiter to take care of everything from taking orders
                to serving food and payment.
              </p>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card">
              <img
                src="assets/img/s1.jpg"
                className="img-thumbnail"
                alt="Crad Number Onr Image"
              />
              <h4 className="sh4 p-3">2. Chinese banquet service</h4>
              <p className="px-2 text-center">
                This is another form of waiter service where each waiter takes
                care of a table or group of tables with 10-12 guests. Dishes are
                usually communal and
              </p>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card">
              <img
                src="assets/img/s3.jpg"
                className="img-thumbnail"
                alt="Crad Number Onr Image"
              />
              <h4 className="sh4 p-3">3. Buffet service</h4>
              <p className="px-3 text-center">
                In a buffet service, guests can choose their food from a wider
                selection made available on the buffet line. There are 4 common
                types of buffet
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Service;
